import enUS from 'antd-mobile/es/locales/en-US';
import arSA from 'antd-mobile/es/locales/ar-SA';
import idID from 'antd-mobile/es/locales/id-ID';
import ptBR from 'antd-mobile/es/locales/pt-BR';
import esES from 'antd-mobile/es/locales/es-ES';
import frFR from 'antd-mobile/es/locales/fr-FR';
import deDE from 'antd-mobile/es/locales/de-DE';
import ruRU from 'antd-mobile/es/locales/ru-RU';
import viVN from 'antd-mobile/es/locales/vi-VN';
import thTH from 'antd-mobile/es/locales/th-TH';
import trTR from 'antd-mobile/es/locales/tr-TR';

type AntdLocale = typeof enUS;

// Map our i18n codes (SUPPORTED_LANGUAGES) to the antd-mobile locale antd-mobile
// actually ships. Codes not listed here (hi, bn, gu, kn, ml, mr, or, pa, ta, te,
// iw, pl, ur — antd-mobile has no bundle for them) fall back to en-US, so the
// built-in component strings (mainly the Calendar weekday/title row) stay English.
const ANTD_LOCALE_MAP: Record<string, AntdLocale> = {
  en: enUS,
  en_AU: enUS,
  ar: arSA,
  id: idID,
  pt: ptBR,
  es: esES,
  fr: frFR,
  de: deDE,
  ru: ruRU,
  vi: viVN,
  th: thTH,
  tr: trTR,
};

// Resolve the antd-mobile locale for the active i18n language, falling back to en-US.
export const getAntdLocale = (lng?: string | null): AntdLocale =>
  (lng && ANTD_LOCALE_MAP[lng]) || enUS;
